import 'core-js/stable';
//import 'core-js/modules/es.object.assign';
//import 'core-js/modules/es.array.from';
import 'regenerator-runtime/runtime';
import smoothscroll from 'smoothscroll-polyfill';
//global.jQuery = global.$ = window.jQuery = require('jquery');

// smooth scroll behavior Polyfill
smoothscroll.polyfill();

// ページ内リンクスムーススクロール（指定IDへスクロール）
/* //commonファイルに記述あり
const scrollToId = function(){
  const anchorLinks = document.querySelectorAll('a[href^="#"]');
  [].forEach.call(anchorLinks, function(link) {
    link.addEventListener('click', function(e){
      e.preventDefault();
      // 固定ヘッダーなどの固定要素がある場合はその分の高さを考慮
      // 固定要素のセレクタはコードに合わせて適宜変更
      const headerHeight = document.querySelector('header') !== null ? document.querySelector('header').clientHeight : 0;
      const targetId = link.hash;
      const targetElement = document.querySelector(targetId);
      const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top - headerHeight;
      window.scrollTo({
        top: targetOffsetTop,
        behavior: "smooth"
      });
    });
  });
};
 scrollToId();
 */
 
// ハッシュ（ID）付きURLでロードされた場合
const loadScrollToId = function(){
  const targetId = location.hash;
  if(!targetId){
    return;
  }
  // 固定ヘッダーなどの固定要素がある場合はその分の高さを考慮
  // 固定要素のセレクタはコードに合わせて適宜変更
  const headerHeight = document.querySelector('header') !== null ? document.querySelector('header').clientHeight : 0;
  const targetElement = document.querySelector(targetId);
  const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top - headerHeight;
  window.scrollTo({
    top: targetOffsetTop,
    behavior: "smooth"
  });
};

// コンテンツ読み込み完了後に実行
window.addEventListener('load', function() {
  // ハッシュ付きURLの場合の位置変更
  loadScrollToId();
});

//iframe ⾼さ取得し適⽤するjavascript
$('iframe').on('load', function(){ try {
  $(this).height(0);
  $(this).height(this.contentWindow.document.documentElement.scrollHeight);
  } catch (e) {
  }
  }).trigger('load');



/*--------------------------------------------------------------------------*
 * splash
 * ========================================================================== */
$(function() {
  const ref = document.referrer
  const href = location.href
  
  if(ref.indexOf('location') != -1 && href.indexOf('location') != -1 ) {
    // 遷移元と遷移先がlocationの時だけ実行したい処理
    // console.log(ref)
    $('#splash,#splash .logo,#splash .cube,#splash .text').hide();
    $('body').removeClass('noscroll');
    $('body').fadeIn(1000);
  } else if ( window.document.body.id === 'top' ) {
    $('body').removeClass('noscroll');
    $('body').fadeIn(1000);
  } else {
    // それ以外
    $('html,body').scrollTop(0);
    //読み込みが完了したら実行する
    // $(window).on('load',function(){
    //   $('#splash,#splash .logo,#splash .cube,#splash .text').fadeOut(1000);
    //   $('body').removeClass('noscroll');
    // });
    setTimeout(() => {
      $('#splash,#splash .logo,#splash .cube,#splash .text').fadeOut(1000);
      $('body').removeClass('noscroll');
    }, "3000")
  }
});


/*--------------------------------------------------------------------------*
 * アニメーション
 * ========================================================================== */
(function() {
  const image = document.querySelectorAll('.js-img');

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.intersectionRatio > 0) {
        entry.target.classList.add('img-animation');
      } else {
        entry.target.classList.remove('img-animation');
      }
    });
  });

  Array.prototype.forEach.call(image, function(img) {
    observer.observe(img);
  });
})();

$(function () {
  $(window).on('load scroll',function () {
    const windowHeight = $(window).height();
    const scroll = $(window).scrollTop();

    $('.js-blur').each(function () {
      const targetPosition = $(this).offset().top;
      if (scroll > targetPosition - windowHeight + 100) {
        $(this).addClass("active");
      }
    });
  });
});


/*--------------------------------------------------------------------------*
 * モーダル
 *--------------------------------------------------------------------------*/
$(function () {
  $('.js-modal-open').each(function () {
    $(this).on('click', function () {
      var target = $(this).data('target');
      var modal = document.getElementById(target);
      $(modal).fadeIn();
      return false;
    });
  });
  $('.js-modal-close').on('click', function () {
    $('.js-modal').fadeOut();
    return false;
  });
});


/*--------------------------------------------------------------------------*
 * ログインページ/ログインフォーム
 *--------------------------------------------------------------------------*/
$( function () {
  var currentPage = $( 'body' ).attr( 'id' ),
    currentPath = window.location.href.indexOf( "login" ),
    currentPath2 = window.location.href.indexOf( "member" );
  if ( currentPath !== -1 || currentPath2 !== -1 ) {
    var pw = {};
    var inputData;
    pw.init = function () {
      // localStorage	のキーの定義
      var limitedKey = window.localStorage.getItem( 'accessData' );
      
      if ( currentPage === 'login' ) {
        if ( limitedKey !== 'shinsapporoLogined' ) {
          // 限定ログインページ初来訪時
          $( '#submit' ).bind( 'click touchstart', function () {
            inputData = $( '#password' ).val();
            pw.auth( inputData );
            // パスワードが間違ってた時にリロードを無効
            return false;
          } );
        } else {
          // 限定ログインページパスワード認証済み時
          window.localStorage.setItem( 'accessData', 'shinsapporoLogined' );
          location.href = '../member/index.html';
        }
      } else {
        // 限定ージに直接遷移した時に認証済みか確認
        loginCheck( limitedKey );
      }
    };

    pw.auth = function ( value ) {
      // md5の暗号を解読
      var str = CybozuLabs.MD5.calc( value );
      if ( str === '2723d092b63885e0d7c260cc007e8b9d' ) {
        window.localStorage.setItem( 'accessData', 'shinsapporoLogined' );
        location.href = '../member/index.html';
      } else {
        alert( 'パスワードが間違っています' );
      }
    }

    var loginCheck = function ( limitedKey ) {
      if ( limitedKey !== 'shinsapporoLogined' ) {
        console.log
        location.href = '../login/index.html';
      }
    }
    
    pw.init();
  }
} );


/*--------------------------------------------------------------------------*
 * タブ
 *--------------------------------------------------------------------------*/
$(function () {
  function changeTab() {
    var tabName = $(this).data('tab');
    var target = $(this).attr('aria-controls');
    $('[data-tab="' + tabName + '"][aria-controls!="' + target + '"]').attr('aria-selected', 'false');
    $('[data-tab="' + tabName + '"][aria-controls="' + target + '"]').attr('aria-selected', 'true');

    $('[data-tab="' + tabName + '"][role="tabpanel"]').attr('aria-hidden', 'true');
    $('#' + target + '[data-tab="' + tabName + '"][role="tabpanel"]').attr('aria-hidden', 'false');

    return false;
  }

  $('[role="tab"]').on('click', changeTab);
});


$(function () {
  var topBtn = $('.c-tab-nav-item a');
  topBtn.click(function () {
    $('#tabTop')
      .animate({ scrollTop: 0 }, 500, 'easeOutQuart');
    return false;
  });

});
